/* eslint-disable max-len */
import { useState } from 'react';
import { useScreenClass } from 'react-grid-system';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import FlexBox, { FlexGrow } from '../../components/FlexBox';
import theme from '../../styles/theme';
import SnackBar from '../../components/SnackBar';
import PillarOverviewCreate from '../../components/PillarOverviewCreate';
import axios from 'axios';
import LoadingSpinner from '../../components/LoadingSpinner';

const Header = styled.h4`
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0px;
  text-align: center;
  color: ${theme.color.darkBlueGray900};
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #94a3b8;
`;

const CustomGrow = styled(FlexGrow)`
  align-self: stretch;
  flex-grow: 0;
  padding: 16px;
  :not(:last-child) {
    // border-bottom: 1px solid #94a3b8;
  }
`;


interface CourseColumn {
  id: 'title' | 'number' | 'pillar' | 'competencies';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}
function CreatePillar(this: any) {
  const screenClass = useScreenClass();
  const [loading, setLoading] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const navigate = useNavigate();
  const createNewPillar = (data: any) => {
    setLoading(true)
    console.log(data)
    axios
      .post('/pillar/new', data)
      .then((res) => {
        setMessage('Created pillar successfully');
        setIsSnackbarOpen(true);
        setLoading(false);
        navigate('/modify/pillar');
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || 'Failed to create pillar!',
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
        setLoading(false)
      });
  }
  return (
    <>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      <CustomFlex
        style={{
          minHeight: 'inherit',
          height: '100%',
          borderBottom: 'none',
          alignItems: 'flex-start',
          overflowY: 'scroll',
          padding: 0,
          background: 'white',
        }}>
        <FlexGrow
          className="visible-scrollbar"
          style={{
            // overflowY: 'scroll',
            // maxHeight: 'calc(100vh - 128px)',
            // minHeight: 'calc(100vh - 128px)',
          }}>
          <FlexBox direction='column'>
            <CustomGrow>
              <Header>Create New Pillar</Header>
            </CustomGrow>
            <CustomGrow>
              {loading && (
                <LoadingSpinner />
              )}
              <PillarOverviewCreate onSaveComplete={(data) => createNewPillar(data)} />
            </CustomGrow>
          </FlexBox>
        </FlexGrow>
      </CustomFlex >
    </>
  );
}
export default CreatePillar;
